import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useLocalization } from '@/hooks/localization'
import { CellRenderer } from '../renderers'
import { CellEditor } from '../editors'
import { getCellStyles } from './utils'

export const LinkSoftTableBodyCell = React.memo(function LinkSoftTableBodyCell (props) {
  const {
    renderer,
    editor,
    commentMode,
    isCurrent,
    isCurrentCol,
    editorActive,
    editorMode,
    columnSizes,
    ...metadata
  } = props
  const {
    readOnly,
    isDisabled,
    className,
    value,
    xCoord,
    yCoord,
    rowTreeCode,
    colTreeCode
  } = metadata

  const { rtl } = useLocalization()
  const style = useMemo(() => getCellStyles(metadata, columnSizes, rtl), [columnSizes, metadata, rtl])
  // const finalValue = value === null || value === undefined || value === '' ? editorInitChar : value
  const finalClassName = classnames(className, 'table-cell', {
    'htDimmed': readOnly,
    'ht-disabled': isDisabled,
    'current': isCurrent,
    'table-column--current': isCurrentCol
  })

  let content
  if (editorActive && !readOnly) {
    const Editor = editor || CellEditor
    const isUserInput = editorMode === 'key'
    content = (
      <div className='table-cell-editor'>
        <Editor
          {...metadata}
          isUserInput={isUserInput} />
      </div>
    )
  } else {
    const Renderer = renderer || CellRenderer
    content = (
      <div className='table-cell-content'>
        <Renderer {...metadata} commentMode={commentMode} />
      </div>
    )
  }

  return <div
    data-cy={`${rowTreeCode}x${colTreeCode}`}
    style={style}
    className={finalClassName}
    title={value}
    data-x={xCoord}
    data-y={yCoord}
  >
    {content}
  </div>
})



// WEBPACK FOOTER //
// ./src/components/report-tables/core/bodyCell.js